/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT AREA.: STYLES --------------- ++++++++++ */
export default theme => ({
	area: {
		marginBottom: pxToEm(60)
	}
});
